import { apiBasic, apiGet, apiTokenNotDecode } from "./requests";

export const logIn = (data = null) => apiTokenNotDecode(data, "login");

export const checkPassword = (data) => apiTokenNotDecode(data, "check-kitchen-password");

export const getOrderManager = () => apiGet("get-order-manager-configurations");

export const setOrderManager = (data = null) => apiBasic(data, "select-order-manager-configuration");
